import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFormat } from "src/models/Doc/Format.models";

interface FormatState {
  formats: IFormat[];
  formatToEdit: IFormat | null;
}

const initialState: FormatState = {
  formats: [],
  formatToEdit: null,
};

const FormatSlice = createSlice({
  name: "Formato",
  initialState,
  reducers: {
    setFormatList: (state, action: PayloadAction<IFormat[]>) => {
      state.formats = action.payload;
    },
    concatListFormat: (
      state: FormatState,
      action: PayloadAction<IFormat[]>
    ) => {
      state.formats = [...state.formats.concat(action.payload)];
    },
    setFormatToEdit: (state, action: PayloadAction<IFormat | null>) => {
      state.formatToEdit = action.payload;
    },
    addFormat: (state, action: PayloadAction<IFormat>) => {
      state.formats.push(action.payload);
    },
    updateFormat: (state, action: PayloadAction<IFormat>) => {
      let itemIndex = state.formats.findIndex(
        item => item.formatId === action.payload.formatId
      );
      if (itemIndex !== -1) state.formats[itemIndex] = action.payload;
    },
    deleteFormat: (state, action: PayloadAction<number>) => {
      const newArray = state.formats.filter(
        item => item.formatId !== action.payload
      );
      state.formats = newArray;
    },
  },
});

export const {
  setFormatList,
  concatListFormat,
  setFormatToEdit,
  addFormat,
  updateFormat,
  deleteFormat,
} = FormatSlice.actions;

export default FormatSlice.reducer;
